import { Avatar, AvatarGroup } from '@chakra-ui/react';
import Avatar1 from 'assets/img/avatars/avatar1.png';
import Avatar2 from 'assets/img/avatars/avatar2.png';
import Avatar3 from 'assets/img/avatars/avatar3.png';
import Avatar4 from 'assets/img/avatars/avatar4.png';

const avatars = [Avatar1, Avatar2, Avatar3, Avatar4, Avatar1, Avatar1, Avatar1, Avatar1];

type TProps = {
    data?: Array<string>;
};

const AvatarsGroupMy = ({ data = avatars }: TProps) => (
    <AvatarGroup max={4} size="sm" fontSize="12px" ml="auto">
        {data.map((avt, key) => (
            <Avatar key={key} src={avt} />
        ))}
    </AvatarGroup>
);

export default AvatarsGroupMy;
